import MyLectureCard from "./MyLectureCard";

const MyLectureCardExist = (props) => {
  const lectures = props.value;
  return (
    <div className="grid gap-3 card_group mobile:grid-cols-2 tablet:grid-cols-2 web:grid-cols-3">
      {lectures?.map((lecture) => {
        return <MyLectureCard key={lecture.id} lecture={lecture} />;
      })}
    </div>
  );
};

export default MyLectureCardExist;
